import React from 'react';

import CENTRO_NEUQUEN from '../../../../assets/swiss-medical-center/centro_odontologico_neuquen.jpg';
import Image from '../../../Commons/Image/Image';

import styles from './OdontoNeuquen.module.scss';

const OdontoNeuquen = () => {
  return (
    <div className={styles.odonto_neuquen}>
      <h3>Centro Odontológico Neuquén</h3>
      <p>
        <strong className={styles.odonto_neuquen__redText}>Dirección: </strong> Juan B. Alberdi 87,
        2º piso (8300) | Neuquén Capital
      </p>
      <p>
        <strong className={styles.odonto_neuquen__redText}>Turnos: </strong>(0299) 448-9444 |
        0810-333-8876
      </p>
      <Image
        src={CENTRO_NEUQUEN}
        alt='Centro Odontológico Neuquén'
        title='Centro Odontológico Neuquén'
        classes={styles.odonto_neuquen__image}
      />
      <p>
        <strong>Especialidades</strong>
      </p>
      <ul>
        <li>Guardia odontológica 12 horas</li>
        <li>Odontología general</li>
        <li>Odontopediatría</li>
        <li>Endodoncia</li>
        <li>Periodoncia</li>
        <li>Ortodoncia</li>
        <li>Cirugía dentomaxilar</li>
        <li>Implantes dentales</li>
        <li>Blanqueamiento dental</li>
        <li>Prótesis dentales</li>
      </ul>
      <p>
        <strong className={styles.odonto_neuquen__redText}>Días y horarios de atención</strong>
      </p>
      <p>Lunes a Viernes | 08 hs. a 20 hs.</p>
      <p>Sábados | 08 hs. a 14 hs.</p>
    </div>
  );
};

export default OdontoNeuquen;
